<template>
  <div :class="{ 'mb-9': ((role == 'space_admin' || role == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || role == 'space_admin' && subscriptionEnds || (role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')) }">
    <SystemBarTopTrial v-if="(role == 'space_admin' || role == 'booster') && productPlan.attributes && productPlan.attributes.name == 'Pro Trial'"/>
    <SystemBarTopCancelSubscription v-if="role == 'space_admin' && subscriptionEnds"/>
    <SystemBarTopPaymentFailed v-if="role == 'space_admin' && productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"/>
    <v-app-bar
      app
      clipped-right
      elevation="0"
      outlined
    > 
      <v-toolbar-title v-if="!mobile()">
        <v-img
          v-if="logo == null"
          data-testid="logo-space"
          src="../assets/rtplogo.svg"
          max-height="40"
          max-width="150"
          class="d-none d-sm-block mx-4 justify-center"
          contain
          position="top left"
        />
        <v-img
          v-else
          data-testid="logo-space"
          :src="logo"
          max-height="40"
          max-width="150"
          class="d-none d-sm-block mx-4 justify-center"
          contain
          position="top left"
        />
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <v-img
          v-if="icon == null"
          data-testid="logo-space"
          src="../assets/rtpicon.png"
          max-height="40"
          max-width="40"
          class="mx-4 justify-center"
          contain
          position="top left"
        />
        <v-img
          v-else
          data-testid="logo-space"
          :src="icon"
          max-height="40"
          max-width="40"
          class="mx-4 justify-center"
          contain
          position="top left"
        />
      </v-toolbar-title>
      <v-divider vertical />
      <h3 class="pl-6">
        <v-clamp
          autoresize
          :max-lines="2"
        >
          {{ activityScormTitle }}
        </v-clamp>
      </h3>
      <v-spacer />
      <ContactUs v-if="(role == 'booster' || role == 'space_admin') && space!='id'" />
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <!--<v-btn v-on="on" :to="'/activity/'+ $route.params.id +'/page/'+ $route.params.pageid" rounded elevation="0" exact>{{ $t('exit') }}<v-icon>mdi-logout</v-icon></v-btn>-->
          <v-btn
            rounded
            elevation="0"
            exact
            v-on="on"
            @click="redirectToActivityScorm"
          >
            {{ $t('exit') }}
            <v-icon>mdi-logout</v-icon>
          </v-btn> 
        </template>
        <span>{{ $t('exitEditMode') }}</span>
      </v-tooltip>
    </v-app-bar>
  </div>
</template>

<script>
import VClamp from 'vue-clamp';
import { getActivityScorm} from '../api/activityApi'
import ContactUs from '../components/ContactUs';
import SystemBarTopTrial from '../components/SystemBarTopTrial';
import SystemBarTopCancelSubscription from '../components/SystemBarTopCancelSubscription'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import SystemBarTopPaymentFailed from '../components/SystemBarTopPaymentFailed'
export default {
    components: {
        VClamp,
        ContactUs,
        SystemBarTopTrial,
        SystemBarTopCancelSubscription,
        SystemBarTopPaymentFailed,
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            drawer: null,
            activityScormTitle: '',
            spaceId: window.$cookies.get('space_id'),
            scormId:this.$route.params.scormId,
            activityId: this.$route.params.id,
            space: window.location.host.split('.')[0],
            logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
            icon: localStorage.space ? JSON.parse(localStorage.space).icon : null,
            role: localStorage.space ? JSON.parse(localStorage.space).role : null,
            subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
        }
    },
    computed:{
      productPlan() {
          return this.$store.state.productPlan
      }
    },
    async created(){
        const response = await getActivityScorm(this.scormId)
        this.activityScormTitle = response.data.data.attributes.title
    },
    methods: {
        releaseEditor(){
          var payload = {'key1': this.scormId, 'key2': this.activityId,'key3': 'scorm' }
          this.$store.dispatch("releaseEditor", payload)
        },
        redirectToActivityScorm(){          
            this.dialogVisible=false
            if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
              this.releaseEditor();
            }
            this.$router.push({path: '/activity/' + this.activityId + '/scorm/' + this.scormId})
        }
    }
}
</script>

